import axios from "axios";
import { apiVariable } from "./apiVariable";
import {
  ResignationLetterCreateUpdateDto,
  ResignationLetterDto,
} from "../interfaces/HR/resignationLetter";

const endpoint = `${apiVariable}/hr/resignation-letters`;

export const getResignationLetters = async (token: string) => {
  const { data } = await axios.get<ResignationLetterDto[]>(endpoint, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const createResignationLetter = async (
  token: string,
  payload: ResignationLetterCreateUpdateDto,
) => {
  const { data } = await axios.post<ResignationLetterDto>(endpoint, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const updateResignationLetter = async (
  token: string,
  payload: ResignationLetterCreateUpdateDto,
) => {
  const { data } = await axios.put<ResignationLetterDto>(endpoint, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const deleteResignationLetter = async (token: string, id: string) => {
  await axios.delete(`${endpoint}/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
